import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default from 'react';
import ReactSelect from 'react-select';
import classNames from 'classnames';
import NvLabel from '../NvLabel/NvLabel.esm.js';
import { checkValidLabel } from '../utils/accessibility.esm.js';
import DropdownIndicator from './NvDropdownIndicator.esm.js';

function NvSelect(_a) {
    var _b;
    var name = _a.name, _c = _a.options, options = _c === void 0 ? [] : _c, classNamePrefix = _a.classNamePrefix, error = _a.error, isClearable = _a.isClearable, errorText = _a.errorText, _d = _a.classes, classes = _d === void 0 ? {} : _d, hideLabel = _a.hideLabel, label = _a.label, components = _a.components, _e = _a.closeMenuOnSelect, closeMenuOnSelect = _e === void 0 ? true : _e, noOptionsMessage = _a.noOptionsMessage, props = __rest(_a, ["name", "options", "classNamePrefix", "error", "isClearable", "errorText", "classes", "hideLabel", "label", "components", "closeMenuOnSelect", "noOptionsMessage"]);
    checkValidLabel(label, name);
    var _f = {
        catskill: 'rgb(238, 243, 248)',
        cooledCarbon: 'rgb(50, 51, 54)',
        deepTeal: 'rgb(18, 130, 121)',
        errorColor: 'rgb(205, 31, 31)',
        gray3: 'rgb(168, 170, 179)',
        gray6: 'rgb(241, 241, 247)',
        ocean: 'rgb(44, 107, 170)',
    }, catskill = _f.catskill, cooledCarbon = _f.cooledCarbon, deepTeal = _f.deepTeal, errorColor = _f.errorColor, gray3 = _f.gray3, gray6 = _f.gray6, ocean = _f.ocean;
    return (React__default.createElement("div", { className: classNames('nv-form-control', classes.root, (_b = {},
            _b['nv-form-control--error'] = !!error,
            _b)) },
        React__default.createElement(NvLabel, { className: classNames('nv-form-label', classes.label), htmlFor: name, isHidden: hideLabel, value: label }),
        React__default.createElement(ReactSelect, __assign({}, props, { "aria-label": label, classNamePrefix: classNamePrefix || 'select', closeMenuOnSelect: closeMenuOnSelect, components: __assign({ DropdownIndicator: DropdownIndicator }, components), instanceId: name, isClearable: isClearable, name: name, noOptionsMessage: function () { return noOptionsMessage; }, options: options, styles: {
                control: function (provided) {
                    var border = error ? "1px solid ".concat(errorColor) : "1px solid ".concat(gray3);
                    return __assign(__assign({}, provided), { '&:hover': {
                            border: border,
                        }, border: border, borderRadius: '3px' });
                },
                dropdownIndicator: function (provided, state) { return (__assign(__assign(__assign({}, provided), { '&:hover': {
                        color: error ? errorColor : deepTeal,
                    }, color: deepTeal, padding: 2 }), (state.selectProps.menuIsOpen && { transform: 'rotate(180deg)' }))); },
                indicatorsContainer: function (provided) { return (__assign(__assign({}, provided), { padding: 5 })); },
                indicatorSeparator: function (provided) { return (__assign(__assign({}, provided), { display: 'none' })); },
                menu: function (provided) { return (__assign(__assign({}, provided), { zIndex: 'var(--zIndexNvSelect)' })); },
                menuList: function (provided) { return (__assign(__assign({}, provided), { padding: '0px' })); },
                multiValue: function () { return ({
                    '.select__multi-value__label': {
                        alignItems: 'center',
                        color: ocean,
                        display: 'flex',
                        fontSize: '16px',
                        whiteSpace: 'unset',
                    },
                    '.select__multi-value__remove:hover': {
                        background: 'none',
                        color: 'unset',
                        cursor: 'pointer',
                    },
                    background: catskill,
                    color: ocean,
                    display: 'flex',
                    marginRight: 5,
                    marginTop: 5,
                    minHeight: 34,
                    svg: {
                        height: '20px',
                        width: '20px',
                    },
                }); },
                option: function (provided, state) {
                    if (state.isFocused || state.isSelected) {
                        return __assign(__assign({}, provided), { backgroundColor: gray6, color: '#161616' });
                    }
                    return __assign({}, provided);
                },
                placeholder: function (provided) { return (__assign(__assign({}, provided), { fontSize: '16px', lineHeight: '18px' })); },
                valueContainer: function (provided, state) { return (__assign(__assign({}, provided), { minHeight: 44, padding: 5, paddingTop: state.isMulti ? 0 : 5 })); },
            }, theme: function (theme) { return (__assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), { primary: cooledCarbon }) })); } })),
        error && errorText && React__default.createElement("p", { className: classNames('nv-form-legend', classes.errorMessage) }, errorText)));
}

export { NvSelect as default };
//# sourceMappingURL=NvSelect.esm.js.map
